export class RepositoryAsset {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "RepositoryAssetType",
            "format": ""
        },
        {
            "name": "repositoryId",
            "baseName": "repositoryId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "commitSha",
            "baseName": "commitSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "rootPath",
            "baseName": "rootPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "manifestPath",
            "baseName": "manifestPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "warning",
            "baseName": "warning",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RepositoryAsset.attributeTypeMap;
    }
    constructor() {
    }
}
